"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _upgradeDataStates = require("ui-addon-upgrades/_core/common/data/upgradeData/upgradeDataStates");

var _validateApp = require("ui-addon-upgrades/_core/common/data/upgradeData/validators/validateApp");

var _validateScreen = require("ui-addon-upgrades/_core/common/data/upgradeData/validators/validateScreen");

var _validateUpgradeProduct = require("ui-addon-upgrades/_core/common/data/upgradeData/validators/validateUpgradeProduct");

var _validateUniqueId = require("ui-addon-upgrades/_core/common/data/upgradeData/validators/validateUniqueId");

var _getValidationStatus = function _getValidationStatus(properties, validators) {
  var validationStatuses = [];
  Object.keys(properties).forEach(function (key) {
    var validator = validators[key];

    if (!validator) {
      return _upgradeDataStates.UPGRADE_DATA_VALID;
    }

    validationStatuses.push(validator(properties[key]));
    return undefined;
  });

  if (validationStatuses.indexOf(_upgradeDataStates.UPGRADE_DATA_INVALID) !== -1) {
    return _upgradeDataStates.UPGRADE_DATA_INVALID;
  }

  return _upgradeDataStates.UPGRADE_DATA_VALID;
};

var _default = function _default(upgradeData) {
  var PROPERTIES = {
    app: upgradeData.app,
    screen: upgradeData.screen,
    upgradeProduct: upgradeData.upgradeProduct,
    uniqueId: upgradeData.uniqueId
  };
  var PROPERTY_VALIDATORS = {
    app: _validateApp.validateApp,
    screen: _validateScreen.validateScreen,
    uniqueId: _validateUniqueId.validateUniqueId,
    upgradeProduct: _validateUpgradeProduct.validateUpgradeProduct
  };
  return _getValidationStatus(PROPERTIES, PROPERTY_VALIDATORS);
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/data/upgradeData/validateUpgradeData.js
// module id = 664
// module chunks = 5 6